import classNames from 'classnames'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next-nprogress-bar'
import { MouseEventHandler } from 'react'

import { useLocaleContext } from '@src/components/locale/locale.context'
import { DEFAULT_LANGUAGE_CODE } from '@src/config/localisation/locale-config.static-constants'
import { getDeviceIdFromLocalStorage } from '@src/quince-site-common/src/utils/getlb-user-id'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'
import { parseLocale } from '@src/utils/i18n.utils'

import styles from './find-my-order-widget.module.scss'

export default function FindMyOrderWidget() {
  const { t } = useTranslation()
  const router = useRouter()
  const deviceId = getDeviceIdFromLocalStorage()
  const handleClick: MouseEventHandler<HTMLButtonElement | HTMLDivElement> = event => {
    event.stopPropagation()
    trackEvent(TELEMETRY_EVENT_NAMES.FIND_MY_ORDER_WIDGET_CLICKED, {
      formData: { deviceId: deviceId ?? '' },
    })
    router.push(`/find-my-order`)
  }
  const { locale } = useLocaleContext()
  const { language } = parseLocale(locale)

  return (
    <div className={styles.ordersListHeader}>
      <div className={classNames(styles.row, language !== DEFAULT_LANGUAGE_CODE ? styles.rowColumn : '')}>
        <p className={styles.titleText}>{t('dont_know_email')}</p>
        <button onClick={handleClick} className={styles.button}>
          {t('find_account')}
        </button>
      </div>
    </div>
  )
}
